// tokenUtils.js
let tokenRefreshTimeout;

export const setupTokenRefreshTimeout = (tokenExpiry, dispatch, refreshToken, logout) => {
    const now = Date.now();
    const timeUntilExpiry = tokenExpiry - now - 60000; // Refresh 1 minute before expiry

    // Clear any existing timeout to avoid multiple scheduled refreshes
    if (tokenRefreshTimeout) {
        clearTimeout(tokenRefreshTimeout);
    }

    // Schedule refresh token if the token will expire soon
    if (timeUntilExpiry > 0) {
        tokenRefreshTimeout = setTimeout(async () => {
            let retryCount = 0;
            let refreshSuccessful = false;

            while (retryCount < 5 && !refreshSuccessful) {  // Retry logic (5 attempts)
                try {
                    await dispatch(refreshToken()); // Attempt to refresh the token
                    refreshSuccessful = true;
                } catch (error) {
                    console.error('Refresh token attempt failed:', error);
                    retryCount += 1;
                    if (retryCount < 5) {
                        await new Promise(resolve => setTimeout(resolve, 3000)); // Retry delay
                    }
                }
            }

            if (!refreshSuccessful) {
                dispatch(logout()); // Log out if refresh fails after retries
            }
        }, timeUntilExpiry);
    }
};
